// let apiKey = "f6771740";
const APIKEY = process.env.REACT_APP_MOVIES_API_KEY

export function getMovies(titulo) {
  return function (dispatch) {
    fetch(`https://www.omdbapi.com/?apikey=${APIKEY}&s=` + titulo)
      .then((response) => response.json())
      .then((json) => {
        dispatch({
          type: "GET_MOVIES",
          payload: json
        });
      });
  };
}

export function addMovieFavorite(payload) {
  return {
    type: "ADD_MOVIE_FAVORITE",
    payload
  };
}

export function removeMovieFavorite(idMovie) {
  return {
    type: "REMOVE_MOVIE_FAVORITE",
    payload: idMovie
  }
}

export function getMovieDetail(idMovie) {
  return function (dispatch) {
    fetch(`https://www.omdbapi.com/?apikey=${APIKEY}&i=` + idMovie)
      .then((response) => response.json())
      .then(data => {
        dispatch({
          type: "GET_MOVIE_DETAIL",
          payload: data
        })
      })
  }
}